import React from 'react';
import I18n from '@/modules/i18n';
import Icon from '@/components/ui/Icon';
import cn from '@/utils/cn';

interface AIBadgeProps {
  disabled?: boolean;
}

const AIBadge = ({ disabled = false }: AIBadgeProps) => (
  <span
    aria-label={I18n.t('ai_generated')}
    className={cn(
      'tw-inline-flex tw-items-center tw-justify-center',
      'tw-h-5 tw-px-2 tw-rounded-full',
      disabled
        ? 'tw-bg-[#777770]'
        : 'tw-bg-gradient-to-b tw-from-[#7954BA] tw-to-[#3F1587]',
    )}
  >
    <Icon fill="white" icon="Sparkle" size={10} />
    <Icon fill="white" height={9} icon="AIText" width={17} />
  </span>
);

export default AIBadge;
